export default {
  "content": "<circle cx=\"12\" cy=\"12\" r=\"9.5\" fill=\"currentColor\" stroke=\"var(--Background)\" stroke-width=\"3\"/><path d=\"M9 15l6-6M9 9h6v6\" stroke=\"#fff\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none"
  }
};